module.exports = __webpack_public_path__ + "img/restore-icon.e4872cac.svg";